// Font
export const MUITypography = {
  fontFamily: ["Karla"].join(","),
  h1_regular_L: {
    fontSize: "3.75rem", // 60px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h1_semiBold_L: {
    fontSize: "3.75rem", // 60px
    fontWeight: "600",
    fontFamily: "Karla",
  },
  h1_bold_L: {
    fontSize: "3.75rem", // 60px
    fontWeight: "bold",
    fontFamily: "Karla",
  },
  h2_regular_L: {
    fontSize: "2.625rem", // 42px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h2_semiBold_L: {
    fontSize: "2.625rem", // 42px
    fontWeight: "600",
    fontFamily: "Karla",
  },
  h2_bold_L: {
    fontSize: "2.625rem", // 42px
    fontWeight: "bold",
    fontFamily: "Rubik",
  },
  h3_regular_L: {
    fontSize: "2rem", // 32px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h3_semiBold_L: {
    fontSize: "2rem", // 32px
    fontWeight: "600",
    fontFamily: "Karla",
  },
  h3_bold_L: {
    fontSize: "2rem", // 32px
    fontWeight: "bold",
    fontFamily: "Karla",
  },
  h4_regular_L: {
    fontSize: "1.563rem", // 25px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h4_semiBold_L: {
    fontSize: "1.563rem", // 25px
    fontWeight: "600",
    fontFamily: "Karla",
  },
  h4_bold_L: {
    fontSize: "1.563rem", // 25px
    fontWeight: "bold",
    fontFamily: "Karla",
  },
  h5_regular_L: {
    fontSize: "1.25rem", // 20px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h5_semiBold_L: {
    fontSize: "1.25rem", // 20px
    fontWeight: "600",
    fontFamily: "Karla",
  },
  h5_bold_L: {
    fontSize: "1.25rem", // 20px
    fontWeight: "bold",
    fontFamily: "Karla",
  },
  subtitle1_L: {
    fontSize: "1rem", // 16px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  subtitle2_L: {
    fontSize: "0.875rem", // 14px
    fontWeight: "500",
    fontFamily: "Karla",
  },
  body1_L: {
    fontSize: "1rem", // 16px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  body1_light_L: {
    fontSize: "1rem", // 16px
    fontWeight: "300",
    fontFamily: "Karla",
  },
  body1_bold_L: {
    fontSize: "1rem", // 16px
    fontWeight: "700",
    fontFamily: "Karla",
  },
  body2_L: {
    fontSize: "0.875rem", // 14px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  body2_light_L: {
    fontSize: "1rem", // 16px
    fontWeight: "300",
    fontFamily: "Karla",
  },
  body2_bold_L: {
    fontSize: "0.875rem", // 14px
    fontWeight: "700",
    fontFamily: "Karla",
  },
  body2_S: {
    fontSize: "0.75rem", // 12px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  h1_S: {
    fontSize: "2.125rem", // 34px
    fontWeight: "700",
    fontFamily: "Karla",
  },
  title_S: {
    fontSize: "1.25rem", // 20px
    fontWeight: "700",
    fontFamily: "Rubik",
  },
  body_S: {
    fontSize: "0.875rem", // 14px
    fontWeight: "400",
    fontFamily: "Karla",
  },
  body_light_S: {
    fontSize: "0.875rem", // 14px
    fontWeight: "300",
    fontFamily: "Karla",
  },
  body_bold_S: {
    fontSize: "0.875rem", // 14px
    fontWeight: "700",
    fontFamily: "Karla",
  },
  custom_italic_L: {
    fontSize: "1.25rem", // 20px
    fontWeight: "500",
    fontStyle: "italic",
    lineHeight: "28px",
    fontFamily: "Karla",
  },
  custom_italic_S: {
    fontSize: "1rem", // 16px
    fontWeight: "400",
    fontStyle: "italic",
    lineHeight: "24px",
    fontFamily: "Karla",
  },
  mobile_title: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "30px",
    fontFamily: "Rubik",
  },
  tablet_title: {
    fontSize: "42px",
    fontWeight: "700",
    lineHeight: "45px",
    fontFamily: "Rubik",
  },
  desktop_title: {
    fontSize: "60px",
    fontWeight: "700",
    lineHeight: "70px",
    fontFamily: "Rubik",
  },
  mobile_title_desc: {
    fontSize: "17px",
    fontWeight: "700",
    lineHeight: "32px",
    fontFamily: "Karla",
  },
};
